import { history } from '../../helpers';
import { alertActions } from './';
import { userAPIs, donationAPIs, countriesAPIs } from '../../api';
import { SET_DEFAULT_AMOUNT_OPTIONS, SET_HBL_CONFIG, SET_RECURRING_DEFAULT_OPTIONS, SET_TAX_DONATION_MESSAGES } from '../actionTypes';
import Tracking, { TRACKING_PAGE_PROPS } from '../../services/tracking.service';
import { WEB_URL } from '../../api/URLs';
import { PAGENAME_CONSTANTS } from '../../constants';

function getHBLConfig(payload) {

    return async dispatch => {
        dispatch(donationActions.updateLoaderState(true));
        try {
            const response = await donationAPIs.HBLCheckout(payload);
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch({
                    type: SET_HBL_CONFIG,
                    response: response.data.data,
                })
            }
        }
        catch {
            return false;
        }
        finally {
            dispatch(donationActions.updateLoaderState(false));
        }
    };
}

function getTaxDonationMessage(countryId) {

    return async dispatch => {
        try {
            const response = await countriesAPIs.getTaxDonationMessgaes(countryId);
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch({
                    type: SET_TAX_DONATION_MESSAGES,
                    response: response.data.data[0],
                })
            }
        }
        catch {
            return false;
        }
    };
}

function calculateProductImpact(currency_id, donation_amount, impact_type = 1, view_type = '') {
    return async dispatch => {

        let payload = {
            currency_id: currency_id,
            value: donation_amount || 0,
            impact_type: impact_type
        };
        try {
            const response = await donationAPIs.calculateProductImpact(payload)
            if (response.data.error) {
                return false;
            }
            if (response.data.success) {
                if (view_type === 'show') {
                    dispatch(showProductImpact(response.data.success));
                } else {
                    dispatch(changeProductImpact(response.data.success));
                }
            }
        }
        catch {
            return false
        }
    };
}

function fetchAllCurrencies() {
    return async dispatch => {
        try {
            const response = await countriesAPIs.fetchAllCurrencies();
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(exportAllCurrencies(response.data.data));
            }
        }
        catch {
            return false;
        }
    };
}

function getStripePaymentIntent(payload, campaign_page = 0) {
    return async dispatch => {
        try {
            const response = await donationAPIs.getStripIntent(payload, campaign_page)
            if (response && response.data && response.data.success) {
                dispatch(stripePaymentIntent(response.data.success));
            } else if (response && response.data && response.data.error) {
                dispatch(updateLoaderState(false));
                dispatch(alertActions.error(response.data.error.toString()));
            }
        }
        catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message
            dispatch(updateLoaderState(false));
            dispatch(alertActions.error(errorMessage));
        }
    };
}

function checkoutStripe(payload, campaign_page = 0) {
    return async dispatch => {
        dispatch(updateLoaderState(true))
        try {
            const response = await donationAPIs.stripeCheckout(payload, campaign_page)
            if (response && response.data && response.data.success) {
                dispatch(updateLoaderState(false))
                dispatch(alertActions.success('Payment Successfull.'));
                window.location.href = WEB_URL.THANK_YOU(response.data.success);
            }
            else if (response && response.data && response.data.success_noemail) {
                dispatch(updateLoaderState(false))
                dispatch(alertActions.success('Payment Successfull.'));
                window.location.href = WEB_URL.THANK_YOU(response.data.success_noemail);
            }
            else {
                dispatch(updateLoaderState(false))
                if (response && response.data && response.data.error) {
                    if (response.data.error.type === "invalid_request_error") {
                        dispatch(alertActions.error("We are sorry, there was an error processing your payment. Please try again with a different payment method."));
                        history.go();

                    } else {
                        dispatch(alertActions.error(response.data.error.toString()));
                        history.go();
                    }
                }
            }
        }
        catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message
            dispatch(alertActions.error(errorMessage));
        }
    }
}

function checkoutPaypal(payload, campaign_page = 0) {
    return async dispatch => {
        try {
            const response = await donationAPIs.paypalCheckout(payload, campaign_page);
            dispatch(updateLoaderState(false));
            if (response && response.data && response.data.success) {
                dispatch(alertActions.success('Payment Successfull.'));
                // history.push('/thank-you/' + response.data.success);
                window.location.href = WEB_URL.THANK_YOU(response.data.success);
            } else if (response && response.data && response.data.success_noemail) {
                dispatch(alertActions.success('Payment Successfull.'));
                // history.push('/thank-you/' + response.data.success_noemail);
                window.location.href = WEB_URL.THANK_YOU(response.data.success_noemail);
            } else {
                if (response && response.data && response.data.error) {
                    dispatch(alertActions.error(response.data.error.toString()));
                }
            }
        }
        catch (error) {
            dispatch(updateLoaderState(false));
            dispatch(alertActions.error(error.message.toString()));
        }
    };
}

function checkoutOnetimePaypal(payload, campaign_page = 0) {
    return async dispatch => {
        dispatch(updateLoaderState(true))
        try {
            const response = await donationAPIs.paypalCheckout(payload, campaign_page);
            if (response && response.data && response.data.success) {
                dispatch(alertActions.info('Please wait, redirecting to paypal account'));
                window.location.href = response.data.success;
                dispatch(updateLoaderState(false))
            }
        }
        catch (error) {
            dispatch(updateLoaderState(false));
            dispatch(alertActions.error("Transaction failed, please try again later"));
            throw error
        }
    };
}

function checkoutRecurringPaypal(payload, campaign_page = 0) {
    return async dispatch => {
        try {
            const response = await donationAPIs.paypalCheckout(payload, campaign_page);
            if (response && response.data && response.data.success) {
                dispatch(alertActions.info('Please wait, redirecting to paypal account'));
                // history.push(response.data.success);
                window.location.href = response.data.success;
                dispatch(updateLoaderState(true));
            }
        }
        catch (error) {
            dispatch(updateLoaderState(false));
            dispatch(alertActions.error(error.message.toString()));
            throw error
        }
    };
}

function checkoutBankTransfer(payload, campaign_page = 0) {
    return async dispatch => {
        dispatch(updateLoaderState(true));
        try {
            const response = await donationAPIs.bankCheckout(payload, campaign_page);
            if (response.data.error) {
                dispatch(alertActions.error(response.data.error.toString()));
            }
            if (response.data.message) {
                dispatch(alertActions.error(response.data.message.toString()));
            }
            if (response.data.success) {
                window.location.href = WEB_URL.THANK_YOU(response.data.success);
            } else if (response && response.data.success_noemail) {
                window.location.href = WEB_URL.THANK_YOU(response.data.success_noemail);
            }
        }
        catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message
            dispatch(alertActions.error(errorMessage));
        }
        finally {
            dispatch(updateLoaderState(false));
        }
    };
}

function checkoutChequeDeposit(payload, campaign_page = 0) {
    return async dispatch => {
        dispatch(updateLoaderState(true));
        try {
            const response = await donationAPIs.chequeDeposite(payload, campaign_page)
            if (response.data.error) {
                dispatch(alertActions.error(response.data.error.toString()));
            }
            if (response.data.message) {
                dispatch(alertActions.error(response.data.message.toString()));
            }
            if (response.data.success) {
                window.location.href = WEB_URL.THANK_YOU(response.data.success);
            } else if (response && response.data.success_noemail) {
                window.location.href = WEB_URL.THANK_YOU(response.data.success_noemail);
            }
        }
        catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message
            dispatch(alertActions.error(errorMessage));
        }
        finally {
            dispatch(updateLoaderState(false));
        }
    };
}

function getPaymentMethods(country_id) {
    return async dispatch => {
        let payload = {
            country_id: country_id
        };
        try {
            const response = await donationAPIs.getPaymentMethods(payload);
            if (response.data && response.data.error) {
                dispatch(alertActions.error(response.data.error.toString()));
            }
            if (response.data) {
                dispatch(exportPaymentMethods(response.data.data));
            }
        }
        catch {
            return false;
        }
    };
}

function checkIfCountryHasGiftAid(country_id) {
    return async dispatch => {
        let payload = {
            country_id: country_id
        };
        try {
            const response = await countriesAPIs.giftAidCountryCheck(payload)
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(exportIfGiftAid(response.data.data));
            }
        }
        catch {
            return false
        }
    };
}

function isCountryCorporateMatch(country_id) {
    return async dispatch => {
        let payload = {
            country_id: country_id
        };
        try {
            const response = await countriesAPIs.corporateMatchCountryCheck(payload)
            if (response.data.error) {
                return false;
            }
            if (response.data) {
                dispatch(exportCorporateMatch(response.data.data));
            }
        }
        catch {
            return false
        }
    };
}

function checkIfCountryPartnerIsactiveFundraiser(country_id) {
    return async dispatch => {
        try {
            const response = await countriesAPIs.countryActiveForFundraiserCheck(country_id);
            if (response.data) {
                dispatch(exportIfCountryPartnerActiveForFundraiser(response.data.data));
            }
        }
        catch {
            return false;
        }
    };
}

function checkIfCountryPartnerIsactiveDonor(country_id) {
    return async dispatch => {
        try {
            const response = await countriesAPIs.countryActiveForDonorCheck(country_id);
            if (response.data) {
                dispatch(exportIfCountryPartnerActiveForDonor(response.data.data));
            }
        }
        catch {
            return false;
        }
    };
}

function getBanksList(country_id) {
    return async dispatch => {
        let payload = {
            country_id: country_id
        };
        try {
            const response = await countriesAPIs.getBanksList(payload);
            if (response.data) {
                dispatch(exportBanksList(response.data.data));
            }
        }
        catch {
            return false;
        }
    };
}

function getUserDetails(user_id) {
    return async dispatch => {
        try {
            const response = await userAPIs.getUserDetails(user_id);
            if (response.data) {
                dispatch(changeUserDetails(response.data));
            }
        }
        catch {
            return false;
        }
    };
}

function getDonationDetails(transaction_number, donation_id = 0) {
    return async dispatch => {
        try {
            const response = await donationAPIs.getDonationDetails(transaction_number)
            dispatch(updateLoaderState(false));
            if (response.data.error) {
                dispatch(alertActions.error(response.data.error.toString()));
                return false;
            }
            if (response.data) {
                dispatch(updateDonationDetails(response.data));

                const { DONATION_ID, DONATION_AMOUNT } = TRACKING_PAGE_PROPS;

                Tracking.trackPage({
                    pageName: PAGENAME_CONSTANTS.DONATION_RECEIPT,
                    pageTitle: response.data.data.page_title ? response.data.data.page_title : response.data.data.donated_campaign_name,
                    [DONATION_ID]: response.data.data.donation_id,
                    [DONATION_AMOUNT]: response.data.data.currency_code + ' ' + response.data.data.donation_amount,
                })
            }
        }
        catch {
            return false
        }
    };
}

function getCurrencyDefaultAmounts(country_id) {
    return async dispatch => {
        let payload = {
            country_id: country_id
        };
        try {
            dispatch({ type: SET_DEFAULT_AMOUNT_OPTIONS, recurring: [], nonRecurring: [] });
            const response = await countriesAPIs.getCurrencyAmountChoices(payload);
            
            if (response.data) {

                const recurringAmountOptions = response.data.data.default_recurring_amounts.length ? response.data.data.default_recurring_amounts : response.data.data.default_amounts

                dispatch({ type: SET_DEFAULT_AMOUNT_OPTIONS, recurring: recurringAmountOptions, nonRecurring: response.data.data.default_amounts })
            }
        }
        catch {
            return false;
        }
    };
}

function getCaptureContext(payload) {
    return async dispatch => {
        try {
            const response = await donationAPIs.getCaptureContext(payload)
            if (response.data) {
                return response.data;
            }
        }
        catch {
            return false
        }
    };
}

function verifyUCPayment(payload) {
    return async dispatch => {
        try {
            const response = await donationAPIs.verifyUCpayment(payload)
            if (response.data) {
                window.location.href = WEB_URL.THANK_YOU(response.data.transaction_code);
            }
        }
        catch(errorMessage) {
            dispatch(alertActions.error(errorMessage));
        }
        finally {
            dispatch(updateLoaderState(false));
        }
    };
}

export function changeProductImpact(product_impact) {
    return {
        type: 'PRODUCT_IMPACT',
        product_impact: product_impact
    }
}

export function showProductImpact(show_product_impact) {
    return {
        type: 'SHOW_PRODUCT_IMPACT',
        show_product_impact: show_product_impact
    }
}

export function exportAllCurrencies(currencies) {
    return {
        type: 'FETECHED_ALL_CURRENCIES',
        currencies: currencies
    }
}

export function exportPaymentMethods(payment_methods) {
    return {
        type: 'GET_PAYMENT_METHODS',
        payment_methods: payment_methods
    }
}

export function exportIfGiftAid(if_giftaid) {
    return {
        type: 'CHECK_IF_GIFTAID',
        if_giftaid: if_giftaid
    }
}

export function exportCorporateMatch(if_corporate_match) {
    return {
        type: 'CHECK_IF_CORPORATE_MATCH',
        if_corporate_match: if_corporate_match
    }
}

export function exportIfCountryPartnerActiveForFundraiser(if_partner_active_for_fundraiser) {
    return {
        type: 'CHECK_IF_COUNTRY_PARTNER_ACTIVE_FOR_FUNDRAISER',
        if_partner_active_for_fundraiser: if_partner_active_for_fundraiser
    }
}

export function exportIfCountryPartnerActiveForDonor(if_partner_active_for_donor) {
    return {
        type: 'CHECK_IF_COUNTRY_PARTNER_ACTIVE_FOR_DONOR',
        if_partner_active_for_donor: if_partner_active_for_donor
    }
}

export function exportBanksList(banks_list) {
    return {
        type: 'GET_BANKS_LIST',
        banks_list: banks_list
    }
}

export function exportAllDonationRebates(donation_rebates) {
    return {
        type: 'FETCH_DONATION_REBATES',
        donation_rebates: donation_rebates
    }
}

export function changeHBLData(hbl_config_data) {
    return {
        type: 'FETCH_HBL_CONFIG_DATA',
        hbl_config_data: hbl_config_data
    }
}

export function changeUserDetails(user_profile_details) {
    return {
        type: 'GET_USER_PROFILE_DETAILS',
        user_profile_details: user_profile_details
    }
}

export function updateLoaderState(loader_state) {
    return {
        type: "UPDATE_LOADER_STATE",
        loader_state: loader_state
    }
}

export function updateDonationDetails(donation_details) {
    return {
        type: "GET_DONATION_DETAILS",
        donation_details: donation_details
    }
}

export function stripePaymentIntent(intent_client_secret) {
    return {
        type: 'STRIPE_INTENT_SECRET',
        intent_client_secret: intent_client_secret
    }
}
export const donationActions = {
    calculateProductImpact,
    fetchAllCurrencies,
    checkoutStripe,
    checkoutPaypal,
    getPaymentMethods,
    getBanksList,
    checkoutBankTransfer,
    checkoutChequeDeposit,
    getUserDetails,
    updateLoaderState,
    getDonationDetails,
    getCurrencyDefaultAmounts,
    getCaptureContext,
    checkoutRecurringPaypal,
    checkoutOnetimePaypal,
    checkIfCountryHasGiftAid,
    getStripePaymentIntent,
    checkIfCountryPartnerIsactiveFundraiser,
    checkIfCountryPartnerIsactiveDonor,
    isCountryCorporateMatch,
    getHBLConfig,
    getTaxDonationMessage,
    verifyUCPayment,
};